import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { Service, useRepositoryQuery } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

interface Params {
    service: Service;
    accountId: string;
    isVirtualBill: boolean;
    reservationIds?: string[];
}

export const useAppliedRoutingRulesIds = ({ service, accountId, isVirtualBill, reservationIds }: Params) => {
    const newRoutingRulesPOSEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesPOSEnabled);

    const { data: reservations } = useRepositoryQuery(
        'reservations',
        'getAll',
        {
            accountIds: [accountId],
            reservationIds: reservationIds ?? [],
        },
        {
            enabled: newRoutingRulesPOSEnabled && isVirtualBill && !!reservationIds,
            select: (data) => data.reservations,
        }
    );

    const { data: appliedRoutingRulesIds } = useRepositoryQuery(
        'routingRules',
        'newGetByReservations',
        {
            reservations: reservations
                ? reservations.map((reservation) => ({
                      identifier: reservation.id,
                      serviceId: reservation.serviceId,
                      partnerCompanyId: reservation.partnerCompanyId,
                      travelAgencyId: reservation.travelAgencyId,
                      rateId: reservation.rateId,
                  }))
                : [],
            enterpriseId: service.enterpriseId,
        },
        {
            enabled: !!reservations,
            select: (result) =>
                pipe(
                    result.reservationRoutingRules,
                    array.map((r) => option.fromNullable(r.routingRuleId)),
                    array.compact
                ),
        }
    );

    return isVirtualBill ? appliedRoutingRulesIds : [];
};
